import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 mx-6 mb-6 rounded-3xl relative overflow-hidden shadow-2xl">
      <div className="absolute bottom-0 left-0 right-0 text-slate-800 text-9xl font-bold opacity-5 text-center pb-8 select-none pointer-events-none">
        SIERRA KUSTOM
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-4 cursor-pointer">
              <img
                src="https://static.readdy.ai/image/a5bacf18ca61cb357c27956f131c4424/4bda670db9801ed405ce2fad550ef8f6.png"
                alt="Sierra Kustom Inc."
                className="h-10 w-auto object-contain"
              />
            </Link>
            <h3 className="text-2xl font-bold text-white mb-3">Sierra Kustom Inc.</h3>
            <p className="text-gray-400 leading-relaxed text-sm mb-6">
              Premium interior finishing and cleaning services across Alberta. Licensed, insured, and trusted by homeowners and businesses.
            </p>
            <div className="flex flex-col gap-2">
              <a href="tel:7805178242" className="text-base font-bold text-white hover:text-amber-500 transition-colors flex items-center gap-2 whitespace-nowrap">
                <i className="ri-phone-fill text-amber-500"></i>780-517-8242
              </a>
              <a href="mailto:Info@sierrakustoms.ca" className="text-sm text-gray-300 hover:text-amber-500 transition-colors flex items-center gap-2 whitespace-nowrap">
                <i className="ri-mail-fill text-amber-500"></i>Info@sierrakustoms.ca
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-base font-semibold text-white mb-4">
              <Link to="/services" className="hover:text-amber-400 transition-colors">Services</Link>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/services#trim-doors" className="text-gray-400 hover:text-white transition-colors text-sm">Trim &amp; Doors</Link></li>
              <li><Link to="/services#flooring" className="text-gray-400 hover:text-white transition-colors text-sm">Flooring</Link></li>
              <li><Link to="/services#windows" className="text-gray-400 hover:text-white transition-colors text-sm">Window Installation</Link></li>
              <li><Link to="/services#fencing" className="text-gray-400 hover:text-white transition-colors text-sm">Fencing</Link></li>
              <li><Link to="/services#decks" className="text-gray-400 hover:text-white transition-colors text-sm">Deck Building</Link></li>
              <li><Link to="/services#residential-cleaning" className="text-gray-400 hover:text-white transition-colors text-sm">Residential Cleaning</Link></li>
              <li><Link to="/services#office-cleaning" className="text-gray-400 hover:text-white transition-colors text-sm">Office Cleaning</Link></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-gray-400 hover:text-white transition-colors text-sm">Home</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-white transition-colors text-sm">All Services</Link></li>
              <li><a href="/#portfolio" className="text-gray-400 hover:text-white transition-colors text-sm">Portfolio</a></li>
              <li><a href="/#gallery" className="text-gray-400 hover:text-white transition-colors text-sm">Gallery</a></li>
              <li><a href="/#about" className="text-gray-400 hover:text-white transition-colors text-sm">About Us</a></li>
              <li><a href="/#locations" className="text-gray-400 hover:text-white transition-colors text-sm">Service Areas</a></li>
              <li><a href="/#contact" className="text-gray-400 hover:text-white transition-colors text-sm">Get a Free Quote</a></li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="text-base font-semibold text-white mb-4">Service Areas</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="/#contact" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 text-sm">
                  <i className="ri-map-pin-line text-amber-500 text-xs"></i>Edmonton, AB
                </a>
              </li>
              <li>
                <a href="/#contact" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 text-sm">
                  <i className="ri-map-pin-line text-amber-500 text-xs"></i>Edson, AB
                </a>
              </li>
              <li>
                <a href="/#contact" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 text-sm">
                  <i className="ri-map-pin-line text-amber-500 text-xs"></i>Hinton, AB
                </a>
              </li>
              <li>
                <a href="/#contact" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 text-sm">
                  <i className="ri-map-pin-line text-amber-500 text-xs"></i>Whitecourt, AB
                </a>
              </li>
              <li>
                <a href="/#contact" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 text-sm">
                  <i className="ri-map-pin-line text-amber-500 text-xs"></i>Spruce Grove, AB
                </a>
              </li>
              <li>
                <a href="/#contact" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 text-sm">
                  <i className="ri-map-pin-line text-amber-500 text-xs"></i>All of Alberta
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Horizontal service quick-links strip */}
        <div className="border-t border-slate-700 pt-8 pb-6">
          <p className="text-xs font-bold text-gray-500 uppercase tracking-widest mb-4">Direct Service Links</p>
          <div className="flex flex-wrap gap-2">
            {[
              { label: 'Trim & Door Installation', to: '/services#trim-doors' },
              { label: 'Premium Flooring', to: '/services#flooring' },
              { label: 'Window Installation', to: '/services#windows' },
              { label: 'Fencing', to: '/services#fencing' },
              { label: 'Custom Deck Building', to: '/services#decks' },
              { label: 'Residential Cleaning', to: '/services#residential-cleaning' },
              { label: 'Office Cleaning', to: '/services#office-cleaning' },
              { label: 'Free Quote', to: '/#contact' },
              { label: 'Our Portfolio', to: '/#portfolio' },
              { label: 'Gallery', to: '/#gallery' },
              { label: 'About Us', to: '/#about' },
            ].map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-xs text-gray-500 hover:text-amber-400 border border-slate-700 hover:border-amber-500/40 px-3 py-1.5 rounded-full transition-all whitespace-nowrap"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="border-t border-slate-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © 2025 Sierra Kustom Inc. All rights reserved. |{' '}
            <Link to="/services" className="hover:text-amber-400 transition-colors">Services</Link>{' '}|{' '}
            <a href="/#contact" className="hover:text-amber-400 transition-colors">Contact</a>{' '}|{' '}
            <a href="/#about" className="hover:text-amber-400 transition-colors">About</a>
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
